import React from 'react';

import { sortBy } from 'lodash';
import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPoint,
  GraphInstanceProps
} from '../index';
import { FormatDate } from '../../../../libs/time';
import { IEpxFallRisk } from '../../../../libs/apps/epxfallrisk';

const EpxFallRiskGraphs: React.FC<GraphInstanceProps> = (
  props
): JSX.Element => {
  const graph: GraphBlueprint<IEpxFallRisk> = {
    name: 'FallRisk Graph',
    config: {
      chart: {
        type: null
      },
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: {
          text: null
        }
      },
      yAxis: [
        {
          title: {
            text: '# of Falls'
          },
          min: 0
        },
        {
          title: {
            text: '# of Stumbles'
          },
          min: 0,
          opposite: true
        }
      ],
      responsive: {}
    },
    draw: (sessions, currentOptions) => {
      const options: GraphOptions = {
        series: []
      };
      const fallSeries: GraphSeries = {
        type: 'line',
        name: 'Falls',
        connectNulls: true
      };
      const stumbleSeries: GraphSeries = {
        type: 'line',
        name: 'Stumbles',
        connectNulls: true
      };
      const data: GraphPoint[][] = [[], []];
      sessions = sortBy(sessions, (session) => session.time);
      for (const [i, session] of sessions.entries()) {
        data[0].push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: session.falls,
          x: i
        });
        data[1].push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: session.stumbles,
          x: i
        });
      }
      fallSeries.data = data[0];
      stumbleSeries.data = data[1];
      options.series = [fallSeries, stumbleSeries];
      options.xAxis = {
        ...currentOptions.xAxis
      };
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxFallRisk>
      url="/data/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxFallRiskGraphs;
